export default "__VITE_ASSET__ClWp2LIq__"